module.exports = __webpack_public_path__ + "flyer_background_ocean_drone_112-6e75ee957d257a5a71cf7663c730c0c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_ocean_drone_112.jpg
// module id = 1667
// module chunks = 1